import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import DataTable, { fmtDateTime } from "@/components/DataTable";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function Audit() {
  const { can } = useAuth();
  const [data, setData] = useState({ items: [], total: 0 });
  const [page, setPage] = useState(1);
  const [event, setEvent] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!can.admin) { setLoading(false); return; }
    setLoading(true);
    const p = new URLSearchParams({ page, page_size: "50" });
    if (event) p.set("event_type", event);
    if (email) p.set("user_email", email);
    try { const { data } = await api.get(`/audit?${p.toString()}`); setData(data); } catch {}
    finally { setLoading(false); }
  }, [page, event, email, can.admin]);
  useEffect(() => { load(); }, [load]);

  if (!can.admin) return (
    <div className="p-6 animate-fade-in">
      <PageHeader title="Audit Trail" />
      <div className="bg-white border border-border rounded-sm p-10 text-center" data-testid="audit-access-denied">
        <Lock className="h-8 w-8 mx-auto text-mutedsea mb-2" />
        <p className="text-slate font-medium">Administrator access required</p>
      </div>
    </div>
  );

  const columns = [
    { key: "timestamp", label: "Timestamp", datetime: true },
    { key: "user_email", label: "User" },
    { key: "event_type", label: "Event", badge: true },
    { key: "resource", label: "Resource" },
    { key: "record_id", label: "Record" },
    { key: "detail", label: "Detail" },
    { key: "ip", label: "IP" },
  ];

  return (
    <div className="p-6 animate-fade-in">
      <PageHeader title="Audit Trail" subtitle="Append-only record of every material system event. Normal users cannot alter these records." />
      <div className="flex gap-3 mb-4">
        <Input placeholder="Filter by event type (e.g. record_create)" value={event} onChange={(e) => { setEvent(e.target.value); setPage(1); }} className="max-w-xs bg-white h-9 text-sm" data-testid="audit-event-filter" />
        <Input placeholder="Filter by user email" value={email} onChange={(e) => { setEmail(e.target.value); setPage(1); }} className="max-w-xs bg-white h-9 text-sm" data-testid="audit-user-filter" />
      </div>
      <DataTable columns={columns} rows={data.items.map((i) => ({ ...i, record_id: i.record_id?.slice(0, 8) }))}
        total={data.total} page={page} pageSize={50} onPage={setPage} loading={loading} />
    </div>
  );
}
